import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { RHFTextFieldWithAdornment } from '@openx/components-core/lib/TextField/RHFTextFieldWithAdornment.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import { PackageFields } from '@openx/types/package.ts';
import { currencySymbol } from '@openx/utils/lib/priceFormat.ts';
import { useTranslation } from 'react-i18next';
import { packageLabels } from '../constants.ts';

type DirectRatesSectionProps = {
  currency: string;
};

export function DirectRatesSection({ currency }: DirectRatesSectionProps) {
  const { t } = useTranslation();

  return (
    <FormSection divider title={t('Direct Package Rates')} rightColumnSize={RIGHT_COLUMN_WIDTH} name="DirectRates">
      <RHFTextFieldWithAdornment
        dataTest="package-rate"
        formControlProps={{ margin: 'dense' }}
        label={packageLabels(t)[PackageFields.RATE]}
        name={PackageFields.RATE}
        placeholder="0.00"
        startAdornment={currencySymbol(currency)}
        slotProps={{ input: { sx: { marginTop: 0 } } }}
      />
    </FormSection>
  );
}
